import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';
import { ValidateEmailResponse } from '@/data/types/EmailDomainValidation';

export class ValidateEmail<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	validateEmail = (
		storeId: string,
		query: {
			email: string;
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (loggerCan('trace') && (!this.traceDetails || this.traceDetails.includes('validateEmail'))) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: null ?? {},
				methodName: 'validateEmail',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<ValidateEmailResponse, void>({
			path: `/store/${storeId}/validateemail`,
			method: 'GET',
			query,
			secure: false,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
